<template>
    <div>

        <div class="alert alert-warning" role="alert" v-if="timerRunning == 1">
            Timer already running on a different task #{{ this.timer.item_id }}
        </div>

        <div v-else>
            <div class="task-timer-mini" v-show="timerRunning != 1">
                <div class="row row-timer g-0">
                    <div class="col">
                        <span class="value">{{time.hours}}</span>
                        <span class="increment">Hours</span>
                    </div>

                    <div class="col-auto">
                        <span class="separator">:</span>
                    </div>

                    <div class="col">
                        <span class="value">{{time.minutes}}</span>
                        <span class="increment">Minutes</span>
                    </div>

                    <div class="col-auto">
                        <span class="separator">:</span>
                    </div>

                    <div class="col">
                        <span class="value">{{time.seconds}}</span>
                        <span class="increment">Seconds</span>
                    </div>
                </div>

                <div class="timer-buttons">
                    <button v-show="timerRunning == 0" @click="start" type="button" class="btn btn-timer start"><i class="fas fa-fw fa-play"></i></button>
                    <button v-show="timerRunning == 3" @click="resume" type="button" class="btn btn-timer start"><i class="fas fa-fw fa-play"></i></button>
                    <button v-show="timerRunning == 2" @click="pause" type="button" class="btn btn-timer start"><i class="fas fa-fw fa-pause"></i></button>
                </div>
            </div>


            <div v-show="timerRunning == 3" class="mb-3">
                <label class="control-label">Notes</label>
                <input type="text" v-model="log.reference" class="form-control">
            </div>

            <div v-show="timerRunning == 3" class="row">
                <div class="col">
                    <button @click="destroy" type="button" class="btn text-danger"><i class="far fa-trash-alt"></i></button>
                </div>
                <div class="col-auto">
                    <button @click="stop()" type="button" class="btn btn-rounded btn-primary">Log Effort</button>
                </div>
            </div>


        </div>
    </div>
</template>

<script>

    import { filter, cloneDeep } from 'lodash'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import UserSelect from 'components/form/input/_user-select'

    let timeModel = function() {
        return {
            hours: 0,
            minutes: 0,
            seconds: 0
        }
    }

    export default {
        props: ['propItem', 'userStoryId'],
        components: {
            UserSelect
        },

        data: function () {
            return {
                log: {},
                time: new timeModel(),
                interval: null,
            }
        },

        computed: {
            ...mapGetters('user', ['authorizedSelect']),
            ...mapState('user', ['timer']),

            timerRunning() {
                //Has timer running and is for this item
                if (this.timer && this.timer.item_id == this.propItem.id) {

                    //Current timer but paused
                    if (this.timer.started == null) {
                        return 3
                    }

                    return 2
                }

                //Has timer running for a different task
                if (this.timer) {
                    return 1
                }

                //No timer currently running
                return 0
            }
        },

        mounted: function() {
            this.hasRunningTimer();
        },

        methods: {
            ...mapActions('user', ['startTimer', 'pauseTimer', 'resumeTimer', 'logTimer', 'deleteTimer']),
            ...mapActions('yodizproject/stories', {
                setStoryListProperty: 'setSingleListProperty'
            }),

            ...mapActions('yodizproject/tasks', {
                setTaskListProperty: 'setSingleListProperty'
            }),

            hasRunningTimer() {

                //Clear any running intervals, not always needed as paused timers don't change
                if (this.interval) {
                    clearInterval(this.interval)
                }

                //Only run for the current item
                if (this.timer && this.timer.item_id == this.propItem.id) {

                    //Loop every second when running
                    if (this.timer.started) {
                        this.setRunningTime()

                        this.interval = setInterval(() => {
                            this.setRunningTime()
                        }, 1000)
                    } else {
                        //Set the time incase this is the first page load for a paused timer
                        this.setRunningTime()
                    }
                } else {
                    //When timers are logged, this will clear the text
                    this.time = new timeModel()
                }
            },

            setRunningTime() {
                if (this.timer) {
                    var diff = moment().utc().diff(moment(this.timer.started), 'seconds')
                    var duration = moment.duration(diff, 'seconds');
                    duration.add(this.timer.accumulated, 'seconds');
                    this.time.hours = duration.hours().toString().padStart(2, "0")
                    this.time.minutes = duration.minutes().toString().padStart(2, "0")
                    this.time.seconds = duration.seconds().toString().padStart(2, "0")
                }
            },

            async start() {
                try {
                    await this.startTimer({'item_id': this.propItem.id, user: this.authorizedSelect, started: moment().utc()})

                    this.hasRunningTimer()
                } catch (error) {}
            },

            async pause() {
                try {
                    await this.pauseTimer({'id': this.timer.id, payload: {stopped: moment().utc()}})

                    this.hasRunningTimer()
                } catch (error) {}
            },

            async resume() {
                try {
                    await this.resumeTimer({'id': this.timer.id, payload: {started: moment().utc()}})

                    this.hasRunningTimer()
                } catch (error) {}
            },

            async stop() {
                try {
                    let effortLog = await this.logTimer({'id': this.timer.id, payload: {stopped: moment().utc(), reference: this.log.reference}})

                    console.log(effortLog)
                    this.$store.dispatch('yodizproject/effort/addFromLocalToList', [effortLog.data])

                    //The API should return story and task partials so we don't have to make multiple requests
                    if (effortLog) {
                        if (effortLog.hasOwnProperty('story')) {
                            this.setStoryListProperty({ id: effortLog.story.id, property: 'time_entries_total', value: effortLog.story.time_entries_total })
                        }

                        if (effortLog.hasOwnProperty('item')) {
                            this.setTaskListProperty({ id: effortLog.item.id, property: 'time_entries_total', value: effortLog.item.time_entries_total })
                        }
                    }

                    //This will clear any interval and timer text
                    this.hasRunningTimer()
                    this.resetFormData()
                } catch (error) {}
            },

            async destroy() {
                try {
                    await this.deleteTimer({'id': this.timer.id, payload: {}})

                    //This will clear any interval and timer text
                    this.hasRunningTimer()
                    this.resetFormData()
                } catch (error) {}
            }
        }
    }
</script>
